export default "__VITE_ASSET__CiM_oJz3__"